import { render, staticRenderFns } from "./TiposProductoPantalla.vue?vue&type=template&id=2cb94168&"
import script from "./TiposProductoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TiposProductoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2cb94168', component.options)
    } else {
      api.reload('2cb94168', component.options)
    }
    module.hot.accept("./TiposProductoPantalla.vue?vue&type=template&id=2cb94168&", function () {
      api.rerender('2cb94168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/TiposProductoPantalla.vue"
export default component.exports